/**
 * Crea la ruleta
 * @param {*} scene - Escena actual de Phaser
 */
export function crearRuleta(scene) {

  scene.ruleta = scene.add.image(868, 244, "ruletaEstatica");

  scene.anims.create({
    key: "girarRuleta",
    frames: scene.anims.generateFrameNumbers("ruletaGirando", {
      start: 0,
      end: 3,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.ruletaGirando = scene.add.sprite(868, 244, "ruletaGirando").setVisible(false);
}